import { createBlacklistFilter } from 'redux-persist-transform-filter';

// persistence config
export const authSaveSubsetBlacklistFilter = createBlacklistFilter('auth', [
  'isFetching',
  'error',
]);
